import { gql } from '@apollo/client';

export const INVOICE_FIELDS = gql`
  fragment InvoiceFields on Invoice {
    id
    branch_id
    sale_order_id
    customer_id
    customer_fiscal_profile_id
    folio_number
    series
    serie_external
    folio_external
    status
    uuid
    pac_provider
    subtotal_cents
    tax_cents
    total_cents
    currency
    cfdi_usage
    payment_method_code
    payment_form_code
    tax_regime
    postal_code
    rfc_emisor
    rfc_receptor
    legal_name_receptor
    error_message
    requested_at
    stamped_at
    cancelled_at
    cancel_reason_code
    cancel_substitution_uuid
    created_at
  }
`;

export const INVOICES_QUERY = gql`
  ${INVOICE_FIELDS}
  query Invoices(
    $offset: Int
    $limit: Int
    $sale_order_id: ID
    $customer_id: ID
    $status: InvoiceStatusGql
    $branch_id: ID
  ) {
    invoices(
      offset: $offset
      limit: $limit
      sale_order_id: $sale_order_id
      customer_id: $customer_id
      status: $status
      branch_id: $branch_id
    ) {
      items {
        ...InvoiceFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CUSTOMER_FISCAL_PROFILES_QUERY = gql`
  query CustomerFiscalProfiles($customer_id: String!) {
    customerFiscalProfiles(customer_id: $customer_id) {
      id
      customer_id
      label
      rfc
      legal_name
      tax_regime_code
      postal_code
      street
      exterior_number
      interior_number
      neighborhood
      municipality
      state
      cfdi_usage
      email
      is_default
      status
    }
  }
`;

export const INVOICE_XML_QUERY = gql`
  query InvoiceXml($invoice_id: String!) {
    invoiceXml(invoice_id: $invoice_id) {
      invoice_id
      kind
      content
      content_type
    }
  }
`;

export const INVOICE_PDF_QUERY = gql`
  query InvoicePdf($invoice_id: String!) {
    invoicePdf(invoice_id: $invoice_id) {
      invoice_id
      kind
      content
      content_type
    }
  }
`;

export const REQUEST_CFDI_MUTATION = gql`
  ${INVOICE_FIELDS}
  mutation RequestCfdi($input: RequestCfdiInputGql!) {
    requestCfdi(input: $input) {
      ...InvoiceFields
    }
  }
`;

export const CANCEL_CFDI_MUTATION = gql`
  ${INVOICE_FIELDS}
  mutation CancelCfdi($input: CancelCfdiInputGql!) {
    cancelCfdi(input: $input) {
      ...InvoiceFields
    }
  }
`;

export const CREATE_FISCAL_PROFILE_MUTATION = gql`
  mutation CreateCustomerFiscalProfile($input: CreateCustomerFiscalProfileInputGql!) {
    createCustomerFiscalProfile(input: $input) {
      id
      customer_id
      label
      rfc
      legal_name
      tax_regime_code
      postal_code
      street
      exterior_number
      interior_number
      neighborhood
      municipality
      state
      cfdi_usage
      email
      is_default
      status
    }
  }
`;

export const UPDATE_FISCAL_PROFILE_MUTATION = gql`
  mutation UpdateCustomerFiscalProfile($input: UpdateCustomerFiscalProfileInputGql!) {
    updateCustomerFiscalProfile(input: $input) {
      id
      customer_id
      label
      rfc
      legal_name
      tax_regime_code
      postal_code
      street
      exterior_number
      interior_number
      neighborhood
      municipality
      state
      cfdi_usage
      email
      is_default
      status
    }
  }
`;

export const DEACTIVATE_FISCAL_PROFILE_MUTATION = gql`
  mutation DeactivateCustomerFiscalProfile($input: DeactivateFiscalProfileInputGql!) {
    deactivateCustomerFiscalProfile(input: $input) {
      id
      status
    }
  }
`;

export const SAT_CATALOG_ENTRIES_QUERY = gql`
  query SatCatalogEntries($catalog: String!, $search: String, $limit: Int) {
    satCatalogEntries(catalog: $catalog, search: $search, limit: $limit) {
      code
      description
      extra_json
    }
  }
`;

export const SAT_POSTAL_CODE_QUERY = gql`
  query SatPostalCode($code: String!) {
    satPostalCode(code: $code) {
      code
      state_code
      municipality_code
    }
  }
`;
